// Vue + vue-router で動的にページタイトルを変更する
// by https://qiita.com/livejam_db/items/a9d8a8cbead668bad18e
export default {
  mounted() {
    let { title } = this.$options
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title
      document.title = `Phantom Horizon - ${title}`
    } else {
      document.title = 'Phantom Horizon'
    }
  }
}